// extracted by mini-css-extract-plugin
export default {"page":"accountUnavailable_page__hMVa5"};